import { parseISO } from 'date-fns';

export const isEventPast = (startAt: string, endAt?: string | null): boolean =>
  parseISO(endAt ?? startAt) < new Date();
